import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';

const beginImg: Record<string, { pc: string; h5: string }> = {
    eu: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724406803075/2560_EU.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724406803075/2560_EU.jpg',
    },
    uk: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724406828536/2560_uk.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724406828536/2560_uk.jpg',
    },
};

const Second: FC = () => {
    const { t } = useLang('xcode.xfusion.second');
    const { locale } = getLocal();

    return (
        <div className={styled.Second} id="x-fusion-second">
            <div className="begin">
                <EditorImg className="begin_img" alt={t('title')} pc={beginImg[locale]?.pc || beginImg.eu.pc} h5={beginImg[locale]?.h5 || beginImg.eu.h5} />
            </div>
            <div className="end">
                <div className="middle-central">
                    <div className="end_img">
                        <EditorImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1724745768599/second_eu%20(1).png"
                            h5="https://websiteoss.ecoflow.com/upload/image/1724745786998/second_eu_m%20(1).png"
                            alt={t('title')}
                        />
                    </div>
                    <div className="text">
                        <h6 className="title">{t('title')}</h6>
                        <p className="subtitle font-desc">{t('subtitle')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Second;
